export const links = [
  {
    id: 1,
    name: 'WORK',
    url: '/experience/work',
  },
  {
    id: 2,
    name: 'EDUCATION',
    url: '/experience/education',
  },
  // {
  //   id: 3,
  //   name: 'VOLUNTEER',
  //   url: '/experience/volunteer',
  // },
]